export default __webpack_public_path__ + "static/media/brain-gauge-schedule.a0f01bed.svg";